import * as React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

export const TiptapMenubar = (props: FlexProps) => (
   <Flex
      bgColor="gray.50"
      border="1px"
      borderColor="gray.200"
      borderRadius="md"
      position="sticky"
      px={2}
      py={1}
      top={0}
      zIndex={1}
      flexWrap="wrap"
      {...props}
   >
      {props.children}
   </Flex>
);
